var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.101,
    height: 63.077,
    viewBox: "0 0 84.101 63.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_94193",
    x: 0,
    y: 0,
    width: 84.101,
    height: 63.077,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.401,
    dy: 2.401,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.201,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54327",
    "data-name": "Group 54327",
    transform: "translate(1.2 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94192",
    "data-name": "Path 94192",
    d: "M1341.885,407.543l-.995-6.367-40.579.332,11.662,6.035Z",
    transform: "translate(-1264.076 -401.144)",
    fill: "#af0086"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.2, -1.2)",
    filter: "url(#Path_94193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94193-2",
    "data-name": "Path 94193",
    d: "M1258.078,395.78l-36.146,26.284.046,29.262,76.852-55.874Z",
    transform: "translate(-1220.73 -394.25)",
    fill: "#ea52c6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonPink);
export default __webpack_public_path__ + "static/media/RibbonPink.78e078b235e1c75af3a19e65545f6e6a.svg";
export { ForwardRef as ReactComponent };